import React from 'react';

const EmbedModal = ({ embedCode, onCopy, copied, onClose }) => (
  <div className="gcd-modal-overlay" onClick={onClose}>
    <div className="gcd-modal" onClick={(e) => e.stopPropagation()}>
      <div className="gcd-modal-header">
        <h2 className="gcd-modal-title">Embed Giving Widget</h2>
        <button className="gcd-modal-close" type="button" onClick={onClose}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      </div>
      <hr className="gcd-modal-divider" />
      <div className="gcd-modal-body">
        <p className="gcd-modal-desc">
          Paste this snippet into your website so supporters can donate directly from your site.
          <br />
          For embedded checkout to work, your site must have HTTPS/TLS enabled.
        </p>
        <textarea
          className="gcd-embed-code"
          rows="8"
          readOnly
          value={embedCode}
        />
      </div>
      <div className="gcd-modal-footer">
        <button
          className="btn btn-sm btn-setlist-primary"
          type="button"
          onClick={onCopy}
        >
          {copied ? 'Copied!' : 'Copy Code'}
        </button>
      </div>
    </div>
  </div>
);

export default EmbedModal;
